import { CarouselGridText } from '@/components/ui/data-display/carousels/carousel-grid-text/CarouselGridText';
import { Section } from '@/components/ui/layouts/sections/Section';
import { carouselImageSettings } from '@mage-ui/styled-system/recipes';
import { InstancesCarousel } from '../InstancesCarousel';

export const CarouselTextBlock = ({ data }) => {
  return (
    <Section
      heading={{
        title: data?.fields?.title,
      }}
    >
      <CarouselGridText
        data={{
          description: data?.fields?.description,
        }}
      >
        <InstancesCarousel
          indicatorThreshold={1}
          settings={carouselImageSettings()}
          instances={data?.relations?.CarouselImageList}
        />
      </CarouselGridText>
    </Section>
  );
};
